import {expandChildrenOfCheckboxListEnum, expandChildrenOfRadioEnum} from './ecrf'
import {SCAU} from './scau'
import "jquery-ui/ui/widgets/autocomplete"
import "jquery-ui/ui/widgets/datepicker"
import {formatDate, minusDays, minusMonths, minusMonthsExclusive, minusWeeks, plusWeeks, toDateWithoutYear, toIsoDate, toRemigDate} from "./date";

const IDENTIFICATION_NUMBER = 'rodne-cislo';
const YEAR_OF_BIRTH = 'rok-narozeni';
const SEX_MALE_ENUMERATION = 'pohlavi-muz';
const SEX_FEMALE_ENUMERATION = 'pohlavi-zena';
const PATIENT_INITIALS = 'inicialy';

const HEADACHES_3 = 'bolest-hlavy-3-mesice-zpet';
const HEADACHES_2 = 'bolest-hlavy-2-mesice-zpet';
const HEADACHES_1 = 'bolest-hlavy-1-mesic-zpet';
const HEADACHES_AVERAGE = 'bolest-hlavy-prumerny-pocet';
const DATE_OF_VISIT = 'datum-navstevy';
const DATE_OF_AGREEMENT = 'informovany-souhlas-datum';
const MOH = 'migrena-pri-naduzivani';
const MOH_YES_ENUMERATION = 'migrena-pri-naduzivani-ano';
const MOH_NO_ENUMERATION = 'migrena-pri-naduzivani-ne';
const SIDE_EFFECTS = 'nezadouci-ucinky';
const SIDE_EFFECTS_YES_ENUMERATION = 'nezadouci-ucinky-ano';
const HEIGHT = 'vyska';
const WEIGHT = 'vaha';
const BMI = 'bmi';
const BIOLOGICAL_TREATMENT_PROGRESS = 'pokracovani-biologicke-lecby';
const BIOLOGICAL_TREATMENT_PROGRESS_STOP_ENUMERATION = 'pokracovani-biologicke-lecby-ukonceni';
const BIOLOGICAL_TREATMENT_PROGRESS_PAUSE_ENUMERATION = 'pokracovani-biologicke-lecby-preruseni';
const NEXT_VISIT = 'datum-pristi-navstevy';
const CHANGE_IN_PROFYLACTIC_TREATMENT = 'zmena-v-profylakticke-lecbe';
const HOSPITALIZATION = 'hospitalizace';
const EMERGENCY = 'pohotovost';
const CONCURRENT_TREATMENT = 'ostatni-lecba';
const CHANGE_IN_COMORBIDITIES = 'zmena-v-soubeznych-onemocnenich';
const CHANGE_IN_IDENTIFICATION = 'zmena-v-identifikaci';
const CHANGE_IN_EDUCATION_ANAMNESIS = 'zmena-v-dosazenem-vzdelani';
const CHANGE_IN_WORK_ANAMNESIS = 'zmena-v-pracovni-anamneze';
const BIOLOGICAL_TREATMENT_PROGRESS_SWITCH_REASON = 'pokracovani-biologicke-lecby-switch-duvod';
const BIOLOGICAL_TREATMENT_PROGRESS_STOP_REASON = 'pokracovani-biologicke-lecby-ukonceni-duvod';
const BIOLOGICAL_TREATMENT_PROGRESS_PAUSE_REASON = 'pokracovani-biologicke-lecby-preruseni-duvod';
const BIOLOGICAL_TREATMENT_SWITCH_REASON_SIDE_EFFECTS = 'pokracovani-biologicke-lecby-switch-duvod-nezadouci-ucinky';
const BIOLOGICAL_TREATMENT_PROGRESS_STOP_SIDE_EFFECTS = 'pokracovani-biologicke-lecby-ukonceni-vedlejsi-ucinky';
const BIOLOGICAL_TREATMENT_PROGRESS_PAUSE_SIDE_EFFECTS = 'pokracovani-biologicke-lecby-preruseni-nezadouci-ucinky';
const BIOLOGICAL_TREATMENT_PROGRESS_STOP_REASON_NOT_COOPERATING_ENUMERATION = 'pokracovani-biologicke-lecby-ukonceni-nespoluprace-pacienta';
const BIOLOGICAL_TREATMENT_PROGRESS_STOP_REASON_DEATH_ENUMERATION = 'pokracovani-biologicke-lecby-ukonceni-smrt';
const BIOLOGICAL_TREATMENT_STOP_REASON_DEATH_SIDE_EFFECTS = 'pokracovani-biologicke-lecby-ukonceni-smrt-vysledek-nu';
const BIOLOGICAL_TREATMENT_STOP_REASON_DEATH_SIDE_EFFECTS_YES_ENUMERATION = 'pokracovani-biologicke-lecby-ukonceni-smrt-vysledek-nu-ano';
const CONCURRENT_TREATMENT_NON_STEROIDIAL_DAYS = 'ostatni-lecba-nesteroidni-antirevmatika-dny';
const CONCURRENT_TREATMENT_ANALGETICS_DAYS = 'ostatni-lecba-analgetika-dny';
const CONCURRENT_TREATMENT_TRIPTANES_DAYS = 'ostatni-lecba-triptany-dny';
const CONCURRENT_TREATMENT_OPIATES_DAYS = 'ostatni-lecba-opiaty-dny';
const CONCURRENT_TREATMENT_BARBITURATY_DAYS = 'ostatni-lecba-barbituraty-dny';
const CONCURRENT_TREATMENT_NON_STEROIDIAL_ENUMERATION = 'ostatni-lecba-nesteroidni-antirevmatika';
const CONCURRENT_TREATMENT_ANALGETICS_ENUMERATION = 'ostatni-lecba-analgetika';
const CONCURRENT_TREATMENT_TRIPTANES_ENUMERATION = 'ostatni-lecba-triptany';
const CONCURRENT_TREATMENT_OPIATES_ENUMERATION = 'ostatni-lecba-opiaty';
const CONCURRENT_TREATMENT_BARBITURATY_ENUMERATION = 'ostatni-lecba-barbituraty';
const COMORBIDITIES_YES_CARDIOVASCULAR_OTHER = 'dalsi-onemocneni-ano-komorbidity-kardiovaskularni-onemocneni-kardiovaskularni-onemocneni-jine-kardiovaskularni-onemocneni-specifikujte'
const COMORBIDITIES_YES_LUNG_OTHER = 'dalsi-onemocneni-ano-komorbidity-plicni-onemocneni-plicni-onemocneni-jine-specifikujte';
const COMORBIDITIES_YES_METABOLIC_OTHER = 'dalsi-onemocneni-ano-komorbidity-metabolicke-endokrinni-onemocneni-metabolicke-endokrinni-onemocneni-jine-endokrinni-metabolicke-onemocneni-specifikujte';
const COMORBIDITIES_YES_GASTRO_OTHER = 'dalsi-onemocneni-ano-komorbidity-gastrointestinalni-a-hepatalni-onemocneni-gastrointestinalni-a-hepatalni-onemocneni-jine-specifikujte';
const COMORBIDITIES_YES_URONEFRO_OTHER = 'dalsi-onemocneni-ano-komorbidity-urologicke-nefrologicke-onemocneni-urologicke-nefrologicke-onemocneni-jine-specifikujte';
const COMORBIDITIES_YES_ORTHO_OTHER = 'dalsi-onemocneni-ano-komorbidity-onemocneni-pohyboveho-aparatu-onemocneni-pohyboveho-aparatu-jine-specifikujte';
const COMORBIDITIES_YES_MALIGNITIES_OTHER = 'dalsi-onemocneni-ano-komorbidity-malignity-malignity-jine-maligni-onemocneni-specifikujte';
const COMORBIDITIES_YES_INFECTION_OTHER = 'dalsi-onemocneni-ano-komorbidity-chronicke-infekcni-onemocneni-chronicke-infekcni-onemocneni-jine-specifikujte';
const COMORBIDITIES_YES_EYE_OTHER = 'dalsi-onemocneni-ano-komorbidity-ocni-onemocneni-ocni-onemocneni-jine-specifikujte';
const COMORBIDITIES_YES_NEURO_OTHER = 'dalsi-onemocneni-ano-komorbidity-neurologicke-onemocneni-neurologicke-onemocneni-jine-specifikujte';
const COMORBIDITIES_YES_PSYCHIATRIC_OTHER = 'dalsi-onemocneni-ano-komorbidity-psychiatricke-onemocneni-psychiatricke-onemocneni-jine-specifikujte';
const COMORBIDITIES_YES_OTHER = 'dalsi-onemocneni-ano-komorbidity-jine-specifikujte';
const SUSPECTED_TREATMENT = 'lecivy-pripravek-podezrely';
const UNSUSPECTED_TREATMENT = 'lecivy-pripravek-soubezny';
const UNSUSPECTED_TREATMENT_OTHER = 'lecivy-pripravek-soubezny-jiny-specifikujte';

const SIDE_EFFECT_CLINICAL = 'nu-klinicke';
const SERIOUS_SIDE_EFFECT = 'zavazny-nezadouci-ucinek';
const SERIOUS_SIDE_EFFECT_YES_DEATH_DATE = 'zavazny-nezadouci-ucinek-ano-zaskrtnete-pacient-zemrel-datum';
const SERIOUS_SIDE_EFFECT_YES_ENUMERATION = 'zavazny-nezadouci-ucinek-ano';
const SERIOUS_SIDE_EFFECT_YES_DEATH_ENUMERATION = 'zavazny-nezadouci-ucinek-ano-zaskrtnete-pacient-zemrel';
const SIDE_EFFECT_RESULT = 'vysledek-nezadouciho-ucinku';
const SIDE_EFFECT_RESULT_DEATH_ENUMERATION = 'vysledek-nezadouciho-ucinku-umrti';
const SIDE_EFFECT_RESULT_DEATH_DATE = 'vysledek-nezadouciho-ucinku-umrti-datum';

function calculateBmi(weight, height) {
    const heightInKgs = height / 100;
    return weight / (heightInKgs * heightInKgs);
}

function scaleTo2(num) {
    return Math.round(num * 100) / 100
}

function validateSocialSecurityNumber(value) {
    const pattern = /^\s*(\d\d)(\d\d)(\d\d)[ /]*(\d\d\d)(\d?)\s*$/;
    const match = pattern.exec(value);

    let yearValue = match[1];
    let monthValue = match[2];
    let dayValue = match[3];
    let extValue = match[4];
    let cValue = parseInt(match[5]);
    let sex = 'male';
    let year = parseInt(yearValue);
    let month = parseInt(monthValue);
    let c = parseInt(cValue);

    if (cValue === '') {
        year += (year < 54) ? 1900 : 1800;
    } else {
        let mod = parseInt(yearValue + monthValue + dayValue + extValue) % 11;
        if (mod === 10) {
            mod = 0;
        }
        if (mod !== c) {
            return undefined;
        }

        year += (year < 54) ? 2000 : 1900;
    }

    if (month > 70 && year > 2003) {
        month -= 70;
        sex = 'female';
    } else if (month > 50) {
        month -= 50;
        sex = 'female';
    } else if (month > 20 && year > 2003) {
        month -= 20;
    }

    return {
        year: year,
        month: month,
        day: parseInt(dayValue),
        sex: sex,
    }
}

function registerBmiCalculation() {
    const heightInput = $("input[name=" + HEIGHT + "]");
    const weightInput = $("input[name=" + WEIGHT + "]");
    const bmiInput = $("input[name=" + BMI + "]");

    window.heightValue = heightInput.val();
    window.weightValue = weightInput.val();

    heightInput.on('change', (e) => {
        const value = $(e.target).val();
        window.heightValue = Number(value);

        if (window.heightValue && window.weightValue) {
            bmiInput.val(scaleTo2(calculateBmi(window.weightValue, window.heightValue)))
            bmiInput.prop("readonly", true);
        }
    });

    weightInput.on('change', (e) => {
        const value = $(e.target).val();
        window.weightValue = Number(value);

        if (window.heightValue && window.weightValue) {
            bmiInput.val(scaleTo2(calculateBmi(window.weightValue, window.heightValue)))
            bmiInput.prop("readonly", true);
        }
    });

    // Make the field readonly in the beginning
    bmiInput.prop("readonly", true);
}

function registerDeathSideEffectLogic() {
    $('input[value=' + SERIOUS_SIDE_EFFECT_YES_DEATH_ENUMERATION + ']').on('click', (e) => {
        let seriousSideEffectYesEnum = $('input[value=' + SIDE_EFFECT_RESULT_DEATH_ENUMERATION + ']');
        seriousSideEffectYesEnum.prop('checked', true);
        expandChildrenOfRadioEnum(seriousSideEffectYesEnum);
    });
    $('input[name=' + SERIOUS_SIDE_EFFECT_YES_DEATH_DATE + ']').on('change', (e) => {
        const value = $(e.target).val();
        $('input[name=' + SIDE_EFFECT_RESULT_DEATH_DATE + ']').val(value);
    });
    $('input[name=' + SIDE_EFFECT_RESULT + ']').on('change', (e) => {
        const selectedValue = $(e.target).val();

        let seriousSideEffectYesEnum = $('input[value=' + SERIOUS_SIDE_EFFECT_YES_ENUMERATION + ']');
        const patientDeathEnum = $('input[value=' + SERIOUS_SIDE_EFFECT_YES_DEATH_ENUMERATION + ']');

        if (selectedValue === SIDE_EFFECT_RESULT_DEATH_ENUMERATION) {
            seriousSideEffectYesEnum.prop('checked', true);
            expandChildrenOfRadioEnum(seriousSideEffectYesEnum);

            patientDeathEnum.prop('checked', true);
            expandChildrenOfCheckboxListEnum(patientDeathEnum);
        } else {
            patientDeathEnum.prop('checked', false);
            expandChildrenOfCheckboxListEnum(patientDeathEnum);
        }
    });
    $('input[name=' + SIDE_EFFECT_RESULT_DEATH_DATE + ']').on('change', (e) => {
        const value = $(e.target).val();
        $('input[name=' + SERIOUS_SIDE_EFFECT_YES_DEATH_DATE + ']').val(value);
    });
}

function registerSocialSecurityNumberLogic() {
    const yearOfBirthInput = $('input[name=' + YEAR_OF_BIRTH + ']');
    const sexMaleEnum = $('input[value=' + SEX_MALE_ENUMERATION + ']');
    const sexFemaleEnum = $('input[value=' + SEX_FEMALE_ENUMERATION + ']');

    $('input[name=' + IDENTIFICATION_NUMBER + ']').on('change', (e) => {
        const value = $(e.target).val();
        const ssnData = validateSocialSecurityNumber(value);
        if (!ssnData) {
            return;
        }

        yearOfBirthInput.val(ssnData.year);
        yearOfBirthInput.prop("readonly", true);

        if (ssnData.sex === 'male') {
            sexMaleEnum.prop('disabled', false);
            sexMaleEnum.prop('checked', true);
            sexFemaleEnum.prop('disabled', true);
        } else {
            sexFemaleEnum.prop('disabled', false);
            sexFemaleEnum.prop('checked', true);
            sexMaleEnum.prop('disabled', true);
        }
    })
}

function registerInitialsLogic() {
    $('input[name=' + PATIENT_INITIALS + ']').on('input', (e) => {
        $(e.target).val($(e.target).val().toUpperCase())
    })
}

function registerSeriousSideEffectsLogic() {
    const seriousSideEffectHint = $('.serious-side-effects-hint');
    const seriousSideEffectInput = $('input[name=' + SERIOUS_SIDE_EFFECT + ']');

    seriousSideEffectInput.on('change', (e) => {
        const value = $(e.target).val();
        if (value === SERIOUS_SIDE_EFFECT_YES_ENUMERATION) {
            seriousSideEffectHint.removeClass('hidden')
        } else {
            seriousSideEffectHint.addClass('hidden')
        }
    });
}

function registerSideEffectsLogic() {
    const sideEffectsReportHint = $('.side-efffects-report-hint');

    const selectedSideEffects = new Set();

    function yesLogic(enumName) {
        selectedSideEffects.add(enumName);
        sideEffectsReportHint.removeClass('hidden')
    }

    function noLogic(enumName) {
        selectedSideEffects.delete(enumName);
        if (selectedSideEffects.size < 1) {
            sideEffectsReportHint.addClass('hidden')
        }
    }

    $('input[name="' + BIOLOGICAL_TREATMENT_PROGRESS_SWITCH_REASON + '"]').on('change', (e) => {
        const value = $(e.target).val();

        if (value === BIOLOGICAL_TREATMENT_SWITCH_REASON_SIDE_EFFECTS) {
            yesLogic(BIOLOGICAL_TREATMENT_SWITCH_REASON_SIDE_EFFECTS)
        } else {
            noLogic(BIOLOGICAL_TREATMENT_SWITCH_REASON_SIDE_EFFECTS)
        }
    });

    $('input[name="' + BIOLOGICAL_TREATMENT_PROGRESS_STOP_REASON + '"]').on('change', (e) => {
        const value = $(e.target).val();

        if (value === BIOLOGICAL_TREATMENT_PROGRESS_STOP_SIDE_EFFECTS) {
            yesLogic(BIOLOGICAL_TREATMENT_PROGRESS_STOP_SIDE_EFFECTS)
        } else {
            noLogic(BIOLOGICAL_TREATMENT_PROGRESS_STOP_SIDE_EFFECTS)
        }
    });

    $('input[name="' + BIOLOGICAL_TREATMENT_PROGRESS_PAUSE_REASON + '"]').on('change', (e) => {
        const value = $(e.target).val();

        if (value === BIOLOGICAL_TREATMENT_PROGRESS_PAUSE_SIDE_EFFECTS) {
            yesLogic(BIOLOGICAL_TREATMENT_PROGRESS_PAUSE_SIDE_EFFECTS)
        } else {
            noLogic(BIOLOGICAL_TREATMENT_PROGRESS_PAUSE_SIDE_EFFECTS)
        }
    });

    $('input[name="' + SIDE_EFFECTS + '"]').on('change', (e) => {
        const value = $(e.target).val();

        if (value === SIDE_EFFECTS_YES_ENUMERATION) {
            yesLogic(SIDE_EFFECTS_YES_ENUMERATION)
        } else {
            noLogic(SIDE_EFFECTS_YES_ENUMERATION)
        }
    });

    $('input[name="' + BIOLOGICAL_TREATMENT_STOP_REASON_DEATH_SIDE_EFFECTS + '"]').on('change', (e) => {
        const value = $(e.target).val();

        if (value === BIOLOGICAL_TREATMENT_STOP_REASON_DEATH_SIDE_EFFECTS_YES_ENUMERATION) {
            yesLogic(BIOLOGICAL_TREATMENT_STOP_REASON_DEATH_SIDE_EFFECTS_YES_ENUMERATION)
        } else {
            noLogic(BIOLOGICAL_TREATMENT_STOP_REASON_DEATH_SIDE_EFFECTS_YES_ENUMERATION)
        }
    });

    function registerCheckboxLogic(checkboxName) {
        $('input[value="' + checkboxName + '"]').on('change', (e) => {
            if ($(e.target).is(":checked")) {
                yesLogic(checkboxName)
            } else {
                noLogic(checkboxName)
            }
        });
    }

    function registerNoEnumLogic(enumName, setName) {
        $('input[value="' + enumName + '"]').on('click', (e) => {
            noLogic(setName)
        });
    }

    function registerYesEnumLogic(enumName) {
        $('input[value="' + enumName + '"]').on('click', (e) => {
            yesLogic(enumName)
        });
    }
}

function registerClinicSelect() {
    function getParam(name) {
        if (name = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(location.search))
            return decodeURIComponent(name[1]);
    }

    $('select[name=clinicId]').on('change', (e) => {
        const initials = getParam("initials");
        const socialSecurityNumber = getParam("socialSecurityNumber");
        const clinicId = $(e.target).val();

        let href = '//' + location.host + location.pathname + "?clinicId=" + clinicId;
        if (initials) {
            href += "&initials=" + initials;
        }
        if (socialSecurityNumber) {
            href += "&socialSecurityNumber=" + socialSecurityNumber;
        }
        window.location.href = href;
    })
}

function registerNextVisitDateLogic() {
    const dateOfVisitInput = $('input[name=' + DATE_OF_VISIT + ']');
    const nextVisitInput = $('input[name=' + NEXT_VISIT + ']');

    function ajaxNextVisitDate() {
        const dateValue = dateOfVisitInput.val();
        const progress = $('input[name="' + BIOLOGICAL_TREATMENT_PROGRESS + '"]:checked').val();
        $.ajax({
            type: "GET",
            contentType: "application/json",
            url: "/api/patient-visit/next-visit-date?patientId=" + window.patientId + "&date=" + toIsoDate(dateValue) + "&startingNew=" + window.startingNew + "&treatmentProgress=" + progress,
            cache: false,
            timeout: 600000,
            success: data => {
                nextVisitInput.val(toRemigDate(data));
                nextVisitInput.datepicker("option", "minDate", formatDate(minusWeeks(data, 4)));
                nextVisitInput.datepicker("option", "maxDate", formatDate(plusWeeks(data, 4)));
            },
            error: e => console.log("ERROR : ", e)
        });
    }

    $('input[name="' + BIOLOGICAL_TREATMENT_PROGRESS + '"]').on('change', (e) => {
        const progress = $(e.target).val();
        if (progress === BIOLOGICAL_TREATMENT_PROGRESS_STOP_ENUMERATION || progress === BIOLOGICAL_TREATMENT_PROGRESS_PAUSE_ENUMERATION) {
            nextVisitInput.val("")
        } else {
            if (dateOfVisitInput.val() != null && dateOfVisitInput.val() !== '') {
                ajaxNextVisitDate();
            }
        }
    });

    dateOfVisitInput.on('change', () => {
        const progress = $('input[name="' + BIOLOGICAL_TREATMENT_PROGRESS + '"]:checked').val();
        if (progress !== BIOLOGICAL_TREATMENT_PROGRESS_STOP_ENUMERATION) {
            ajaxNextVisitDate();
        }
    });
}

function registerOtherTreatmentAutocomplete(availableTags, inputName) {
    function split(val) {
        return val.split(/,\s*/);
    }

    function extractLast(term) {
        return split(term).pop();
    }

    $('input[name="' + inputName + '"]')
        .on("keydown", function (event) {
            if (event.keyCode === $.ui.keyCode.TAB &&
                $(this).autocomplete("instance").menu.active) {
                event.preventDefault();
            }
        })
        .autocomplete({
            minLength: 0,
            source: function (request, response) {
                response($.ui.autocomplete.filter(availableTags, extractLast(request.term)).slice(0, 15));
            },
            focus: function () {
                // prevent value inserted on focus
                return false;
            },
            select: function (event, ui) {
                var terms = split(this.value);
                terms.pop();
                terms.push(ui.item.value);
                terms.push("");
                this.value = terms.join(", ");
                return false;
            }
        });
}

function registerMeddraAutocomplete(selector) {
    function split(val) {
        return val.split(/,\s*/);
    }

    function extractLast(term) {
        return split(term).pop();
    }

    $(selector)
        .on("keydown", function (event) {
            if (event.keyCode === $.ui.keyCode.TAB &&
                $(this).autocomplete("instance").menu.active) {
                event.preventDefault();
            }
        })
        .autocomplete({
            minLength: 2,
            source: function (request, response) {
                $.get("/api/meddra/search-llt", {q: extractLast(request.term)}, function (data) {
                    console.log(data)
                    let res = data.map(d => {
                        return {id: d.code, value: d.name}
                    });
                    console.log(res)
                    response(res);
                });
            },
            focus: function () {
                // prevent value inserted on focus
                return false;
            },
            select: function (event, ui) {
                var terms = split(this.value);
                terms.pop();
                terms.push(ui.item.value);
                terms.push("");
                this.value = terms.join(", ");
                return false;
            }
        });
}

function registerHeadacheCalculation() {
    const headaches3 = $("input[name=" + HEADACHES_3 + "]");
    const headaches2 = $("input[name=" + HEADACHES_2 + "]");
    const headaches1 = $("input[name=" + HEADACHES_1 + "]");
    const headachesAverage = $("input[name=" + HEADACHES_AVERAGE + "]");

    window.headaches3Value = Number(headaches1.val());
    window.headaches2Value = Number(headaches2.val());
    window.headaches1Value = Number(headaches3.val());

    function calculateAndSetAverage() {
        if (window.headaches3Value !== undefined && window.headaches2Value !== undefined && window.headaches1Value !== undefined) {
            headachesAverage.val(Math.round((window.headaches3Value + window.headaches2Value + window.headaches1Value) / 3.).toFixed(2));
            headachesAverage.prop("readonly", true);
        }
    }

    headaches3.on('change', (e) => {
        const value = $(e.target).val();
        window.headaches3Value = Number(value);
        calculateAndSetAverage();
    });

    headaches2.on('change', (e) => {
        const value = $(e.target).val();
        window.headaches2Value = Number(value);
        calculateAndSetAverage();
    });

    headaches1.on('change', (e) => {
        const value = $(e.target).val();
        window.headaches1Value = Number(value);
        calculateAndSetAverage();
    });

    // Calculate also in the beginning
    calculateAndSetAverage();
}

function registerHeadacheLabelsCalculation() {
    const dateOfVisitInput = $('input[name=' + DATE_OF_VISIT + ']');
    const headache3label = $('label:contains("3 měsíce zpět *")');
    const headache2label = $('label:contains("2 měsíce zpět *")');
    const headache1label = $('label:contains("1 měsíc zpět *")');

    function setLabels() {
        const dateValue = toIsoDate(dateOfVisitInput.val());

        if (!dateValue || dateValue === 'Invalid date') {
            return;
        }

        headache3label.text(toDateWithoutYear(minusMonths(dateValue, 3)) + " - " + toDateWithoutYear(minusMonthsExclusive(dateValue, 2)) + " *");
        headache2label.text(toDateWithoutYear(minusMonths(dateValue, 2)) + " - " + toDateWithoutYear(minusMonthsExclusive(dateValue, 1)) + " *");
        headache1label.text(toDateWithoutYear(minusMonths(dateValue, 1)) + " - " + toDateWithoutYear(minusDays(dateValue, 1)) + " *");
    }

    dateOfVisitInput.on('change', setLabels);

    // Set labels also in the beginning
    setLabels();
}

function registerDateOfAgreementLogic() {
    const dateOfVisit = $('input[name="' + DATE_OF_AGREEMENT + '"]');
    dateOfVisit.datepicker("option", "minDate", toRemigDate("2021-02-01")); // Month is 0-indexed, who the fuck knew
    dateOfVisit.datepicker("option", "maxDate", toRemigDate(new Date().toJSON().slice(0, 10)));
}

function registerVisitNumberLogic() {
    const visitNumber = $('span.visit-number');
    const treatmentProgressRadio = $('input[name="' + BIOLOGICAL_TREATMENT_PROGRESS + '"]');
    const dateOfVisit = $('input[name="' + DATE_OF_VISIT + '"]');

    // Always set max visit date to now
    dateOfVisit.datepicker("option", "maxDate", new Date().toJSON().slice(0, 10));

    treatmentProgressRadio.on('change', (e) => {
        const value = $(e.target).val();

        $.ajax({
            type: "GET",
            contentType: "application/json",
            url: "/api/patient-visit/visit-date-range?patientId=" + window.patientId + "&treatmentProgress=" + value,
            cache: false,
            timeout: 600000,
            success: data => {
                visitNumber.text(data.number);

                dateOfVisit.parent().find(".invalid-feedback.auto-generated").remove();
                if (data.from > data.to) {
                    dateOfVisit.parent().append("<div class=\"invalid-feedback auto-generated\">Tato pravidelná návštěva by měla proběhnout až v budoucnu</div>");
                }

                dateOfVisit.val("");
                dateOfVisit.datepicker("option", "minDate", toRemigDate(data.from));
                dateOfVisit.datepicker("option", "maxDate", toRemigDate(data.to));
            },
            error: e => console.log("ERROR : ", e)
        });

    })
}

function registerDeathOrNotCooperatingLogic() {

    function hideField(input) {
        input.closest(".ecrf-input-box").hide();
    }

    function showField(input) {
        input.closest(".ecrf-input-box").show();
    }

    function hideOrShow(condition) {
        if (condition) {
            fields.forEach(field => hideField(field))
        } else {
            fields.forEach(field => showField(field))
        }
    }

    const nextVisitField = $('input[name^="' + NEXT_VISIT + '"]');

    const fields = [
        $('input[name^="' + HEIGHT + '"]'),
        $('input[name^="' + WEIGHT + '"]'),
        $('input[name^="' + BMI + '"]'),
        $('input[name^="' + HEADACHES_1 + '"]'),
        $('input[name^="' + HEADACHES_2 + '"]'),
        $('input[name^="' + HEADACHES_3 + '"]'),
        $('input[name^="' + HEADACHES_AVERAGE + '"]'),
        $('input[name^="' + MOH + '"]'),
        $('input[name^="' + SIDE_EFFECTS + '"]'),
        $('input[name^="' + HOSPITALIZATION + '"]'),
        $('input[name^="' + EMERGENCY + '"]'),
        $('input[name^="' + CONCURRENT_TREATMENT + '"]'),
        $('input[name^="' + CHANGE_IN_PROFYLACTIC_TREATMENT + '"]'),
        $('input[name^="' + CHANGE_IN_IDENTIFICATION + '"]'),
        $('input[name^="' + CHANGE_IN_COMORBIDITIES + '"]'),
        $('input[name^="' + CHANGE_IN_WORK_ANAMNESIS + '"]'),
        $('input[name^="' + CHANGE_IN_EDUCATION_ANAMNESIS + '"]'),
        nextVisitField,
    ];

    const treatmentProgress = $('input[name="' + BIOLOGICAL_TREATMENT_PROGRESS + '"]');
    const treatmentProgressStoppedReason = $('input[name="' + BIOLOGICAL_TREATMENT_PROGRESS_STOP_REASON + '"]');

    // Change dynamically during form filling
    treatmentProgressStoppedReason.on('change', (e) => {
        const value = $(e.target).val();
        hideOrShow(value === BIOLOGICAL_TREATMENT_PROGRESS_STOP_REASON_NOT_COOPERATING_ENUMERATION || value === BIOLOGICAL_TREATMENT_PROGRESS_STOP_REASON_DEATH_ENUMERATION);
    });

    treatmentProgress.on('change', (e) => {
        const value = $(e.target).val();
        hideOrShow(false);

        if (value === BIOLOGICAL_TREATMENT_PROGRESS_STOP_ENUMERATION) {
            const value = treatmentProgressStoppedReason.filter(":checked").val();
            hideOrShow(value === BIOLOGICAL_TREATMENT_PROGRESS_STOP_REASON_NOT_COOPERATING_ENUMERATION || value === BIOLOGICAL_TREATMENT_PROGRESS_STOP_REASON_DEATH_ENUMERATION);
            hideField(nextVisitField);
        } else {
            showField(nextVisitField);
        }
    });

    // Change on load
    const treatmentProgressValue = treatmentProgress.filter(":checked").val();
    const value = treatmentProgressStoppedReason.filter(":checked").val();
    hideOrShow(treatmentProgressValue === BIOLOGICAL_TREATMENT_PROGRESS_STOP_ENUMERATION
        && (value === BIOLOGICAL_TREATMENT_PROGRESS_STOP_REASON_NOT_COOPERATING_ENUMERATION || value === BIOLOGICAL_TREATMENT_PROGRESS_STOP_REASON_DEATH_ENUMERATION));
}

function registerPatientSurveyWPAILogic() {

    function hideField(input) {
        input.closest(".ecrf-input-box").hide();
    }

    function showField(input) {
        input.closest(".ecrf-input-box").show();
    }

    function hideOrShow(condition) {
        if (condition) {
            fields.forEach(field => hideField(field))
        } else {
            fields.forEach(field => showField(field))
        }
    }

    const fields = [
        $('input[name^="wpai2"]'),
        $('input[name^="wpai3"]'),
        $('input[name^="wpai4"]'),
        $('input[name^="wpai5"]'),
    ];

    const employed = $('input[name="wpai1"]');

    // Change dynamically during form filling
    employed.on('change', (e) => {
        const value = $(e.target).val();
        hideOrShow(value === 'wpai1-no');
    });

    // Change on load
    const wpai1value = employed.filter(":checked").val();
    hideOrShow(wpai1value === 'wpai1-no');
}

function registerSliderLogic() {
    $("input[type=range]").on('input', (e) => {
        const target = $(e.target);
        target.parent().find('.slider-value').text(target.val());
    });
}

function registerMohCalculation() {

    const nonSteroidialDays = $("input[name=" + CONCURRENT_TREATMENT_NON_STEROIDIAL_DAYS + "]");
    const analgeticsDays = $("input[name=" + CONCURRENT_TREATMENT_ANALGETICS_DAYS + "]");
    const triptanesDays = $("input[name=" + CONCURRENT_TREATMENT_TRIPTANES_DAYS + "]");
    const opiatesDays = $("input[name=" + CONCURRENT_TREATMENT_OPIATES_DAYS + "]");
    const barbituratyDays = $("input[name=" + CONCURRENT_TREATMENT_BARBITURATY_DAYS + "]");
    const concurrentTreatment = $("input[name=" + CONCURRENT_TREATMENT + "]");

    const nonSteroidialEnumeration = $("input[value=" + CONCURRENT_TREATMENT_NON_STEROIDIAL_ENUMERATION + "]");
    const analgeticsEnumeration = $("input[value=" + CONCURRENT_TREATMENT_ANALGETICS_ENUMERATION + "]");
    const triptanesEnumeration = $("input[value=" + CONCURRENT_TREATMENT_TRIPTANES_ENUMERATION + "]");
    const opiatesEnumeration = $("input[value=" + CONCURRENT_TREATMENT_OPIATES_ENUMERATION + "]");
    const barbituratyEnumeration = $("input[value=" + CONCURRENT_TREATMENT_BARBITURATY_ENUMERATION + "]");

    const mohYes = $("input[value=" + MOH_YES_ENUMERATION + "]");
    const mohNo = $("input[value=" + MOH_NO_ENUMERATION + "]");

    function calculateMoh() {
        var NSAID = 0;
        var triptanes = 0;
        var opiatesBarbiturates = 0;

        if (nonSteroidialEnumeration.is(":checked")) {
            NSAID += Number(nonSteroidialDays.val());
        }

        if (analgeticsEnumeration.is(":checked")) {
            NSAID += Number(analgeticsDays.val());
        }

        if (triptanesEnumeration.is(":checked")) {
            triptanes = Number(triptanesDays.val());
        }

        if (opiatesEnumeration.is(":checked")) {
            opiatesBarbiturates += Number(opiatesDays.val());
        }

        if (barbituratyEnumeration.is(":checked")) {
            opiatesBarbiturates += Number(barbituratyDays.val());
        }

        return NSAID > 14 || triptanes > 10 || opiatesBarbiturates > 4;
    }

    function updateMoh() {
        if (calculateMoh()) {
            mohYes.prop('disabled', false);
            mohYes.prop('checked', true);
            mohNo.prop('checked', false);
            mohNo.prop('disabled', true);
        } else {
            mohYes.prop('disabled', true);
            mohYes.prop('checked', false);
            mohNo.prop('checked', true);
            mohNo.prop('disabled', false);
        }
    }

    nonSteroidialDays.on('change', () => updateMoh());
    analgeticsDays.on('change', () => updateMoh());
    triptanesDays.on('change', () => updateMoh());
    opiatesDays.on('change', () => updateMoh());
    barbituratyDays.on('change', () => updateMoh());
    concurrentTreatment.on('change', () => updateMoh());
    nonSteroidialEnumeration.on('change', () => updateMoh());
    analgeticsEnumeration.on('change', () => updateMoh());
    triptanesEnumeration.on('change', () => updateMoh());
    opiatesEnumeration.on('change', () => updateMoh());
    barbituratyEnumeration.on('change', () => updateMoh());

    // Update moh also on page load
    updateMoh();
}


function registerSuspectedDrugLogic() {
    const OTHER_OPTION_NAME = 'jiny';
    $('select[name=' + SUSPECTED_TREATMENT + ']').on('change', (e) => {
        $(e.target).find("option:not(:selected)").each((i, el) => {
            const newValue = $(el).attr('value').replace(SUSPECTED_TREATMENT, '');
            if (newValue !== '-' + OTHER_OPTION_NAME) {
                const checbox = $('input[value=' + UNSUSPECTED_TREATMENT + newValue + ']');
                checbox.prop('disabled', false);
                checbox.prop('checked', true);
            }
        });
        $(e.target).find("option:selected").each((i, el) => {
            const newValue = $(el).attr('value').replace(SUSPECTED_TREATMENT, '');
            if (newValue !== '-' + OTHER_OPTION_NAME) {
                const checkbox = $('input[value=' + UNSUSPECTED_TREATMENT + newValue + ']');
                checkbox.prop('checked', false);
                checkbox.prop('disabled', true);
            }
        });
    });
}

// jQuery plugin to prevent double submission of forms
jQuery.fn.preventDoubleSubmission = function() {
    $(this).on('submit',function(e){
        var $form = $(this);

        if ($form.data('submitted') === true) {
            // Previously submitted - don't submit again
            e.preventDefault();
        } else {
            // Mark it so that the next submit can be ignored
            $form.data('submitted', true);
        }
    });

    // Keep chainability
    return this;
};

function registerDoubleClickStopper() {
    $('form').preventDoubleSubmission();
}

export function registerRemigFeatures() {
    registerBmiCalculation();
    registerSeriousSideEffectsLogic();
    registerDeathSideEffectLogic();
    registerSocialSecurityNumberLogic();
    registerInitialsLogic();
    registerSideEffectsLogic();
    registerClinicSelect();
    registerNextVisitDateLogic();
    registerDeathOrNotCooperatingLogic();
    registerPatientSurveyWPAILogic();
    registerDateOfAgreementLogic();
    registerVisitNumberLogic();
    registerHeadacheCalculation();
    registerHeadacheLabelsCalculation();
    registerMohCalculation();
    registerSliderLogic();

    registerOtherTreatmentAutocomplete(SCAU, UNSUSPECTED_TREATMENT_OTHER);

    registerMeddraAutocomplete('textarea[name="' + SIDE_EFFECT_CLINICAL + '"]');
    registerMeddraAutocomplete('input[name="' + COMORBIDITIES_YES_OTHER + '"]');
    registerMeddraAutocomplete('input[name="' + COMORBIDITIES_YES_CARDIOVASCULAR_OTHER + '"]');
    registerMeddraAutocomplete('input[name="' + COMORBIDITIES_YES_LUNG_OTHER + '"]');
    registerMeddraAutocomplete('input[name="' + COMORBIDITIES_YES_METABOLIC_OTHER + '"]');
    registerMeddraAutocomplete('input[name="' + COMORBIDITIES_YES_GASTRO_OTHER + '"]');
    registerMeddraAutocomplete('input[name="' + COMORBIDITIES_YES_URONEFRO_OTHER + '"]');
    registerMeddraAutocomplete('input[name="' + COMORBIDITIES_YES_ORTHO_OTHER + '"]');
    registerMeddraAutocomplete('input[name="' + COMORBIDITIES_YES_MALIGNITIES_OTHER + '"]');
    registerMeddraAutocomplete('input[name="' + COMORBIDITIES_YES_INFECTION_OTHER + '"]');
    registerMeddraAutocomplete('input[name="' + COMORBIDITIES_YES_EYE_OTHER + '"]');
    registerMeddraAutocomplete('input[name="' + COMORBIDITIES_YES_NEURO_OTHER + '"]');
    registerMeddraAutocomplete('input[name="' + COMORBIDITIES_YES_PSYCHIATRIC_OTHER + '"]');

    registerSuspectedDrugLogic();

    //registerPasiChart();
    //registerPatientsYearlyChart();
    //registerPatientsPerInsuranceChart();
    //registerPatientsInTimeChart();
    //registerWeightChart();
    //registerTreatmentStoppedReasonsChart();
    //registerTreatmentSwitchReasonsChart();

    registerDoubleClickStopper();
}
